import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import type { GeoStateModel } from '@models/types'

import type { AppDispatch } from '@redux/store'
import type {
  Action, EntityOptions, Errors, FetchRequestPayload, RootReducerState,
} from '@redux/modules/types'

import { handleError } from '../utils'

const FETCH_REQUEST = 'realbase/geoState/FETCH_REQUEST'
const FETCH_SUCCESS = 'realbase/geoState/FETCH_SUCCESS'
const FETCH_FAILURE = 'realbase/geoState/FETCH_FAILURE'

export type GeoStateModuleState = {
  errors: Errors,
  loaded: boolean,
  loadedForKeys: string[],
  loading: boolean,
}

// Initial State
const initialState: GeoStateModuleState = {
  errors: [],
  loaded: false,
  loadedForKeys: [],
  loading: false,
}

// Actions
export function fetchRequest(payload: FetchRequestPayload = {}) {
  return {
    type: FETCH_REQUEST,
    loadedForKeys: payload.loadedForKeys,
  }
}

export function fetchSuccess() {
  return {
    type: FETCH_SUCCESS,
  }
}

export function fetchFailure(errors: Errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

// Action Creators
export function loadGeoStates(options: EntityOptions = {}) {
  const { entityKey } = options

  return (dispatch: AppDispatch, getState: () => RootReducerState) => {
    const loadedForKeys = [...getState().geoStates.loadedForKeys]

    if (entityKey) loadedForKeys.push(entityKey)

    dispatch(fetchRequest({ loadedForKeys }))

    const promise = api('/geo_states.json', options)
      .then(({ data }: { data: GeoStateModel[]}) => {
        const normalizedJson = normalize(data, Schemas.GEO_STATE_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true as const, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false as const, errors }
      })

    return promise
  }
}

// Reducer
export default function reducer(state: GeoStateModuleState = initialState, action: Action = { type: '' }) {
  switch (action.type){
    case FETCH_REQUEST:
      return {
        ...state,
        loadedForKeys: action.loadedForKeys || state.loadedForKeys,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        errors: [],
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors: action.errors,
      }
    default:
      return state
  }
}
